import { NEW_USER_CONFIG } from "../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NewUserService = /** @class */ (function () {
    function NewUserService(http) {
        this.http = http;
        this.config = NEW_USER_CONFIG;
    }
    NewUserService.prototype.sell = function (phone, amount, usdc_amount, gameProviderId) {
        return this.http.post(this.config.save, { phone: phone, amount: amount, usdc_amount: usdc_amount, gameProviderId: gameProviderId });
    };
    NewUserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NewUserService_Factory() { return new NewUserService(i0.ɵɵinject(i1.HttpClient)); }, token: NewUserService, providedIn: "root" });
    return NewUserService;
}());
export { NewUserService };
